import React from 'react';
import { makeStyles, Button } from 'design-system';
import Tooltip from 'design-system/Tooltip';
import { useProjectInstructionContext } from '../projectInstructionContext';
import { NormalizedComponentProps } from '../types';
import { Colors } from 'react-scale/components/legacy-css/global_css';

/**
 * Checks if any component has pending timers (has not been read)
 *
 * @param components A list of components
 * @returns `true` if any component has a pending timer, `false` otherwise
 */
const hasPendingTimers = (components: NormalizedComponentProps[]): boolean => {
  return !!components?.find((component: NormalizedComponentProps) => {
    if (component.components) {
      return hasPendingTimers(component.components);
    }
    return !!component.waitSeconds;
  });
};

const StickyFooter = () => {
  const classes = useStyles();
  const {
    isCorpUser,
    components,
    startButtonText,
    handleStart,
    setOpenQuiz,
    enableQuiz,
    customStartButton,
  } = useProjectInstructionContext();

  const disabled = !isCorpUser && hasPendingTimers(components);

  return (
    <div className={classes.container}>
      <Tooltip
        title={disabled ? 'Please read all sections before tasking' : ''}
        arrow
        placement="top"
      >
        <div className={classes.startButton}>
          {customStartButton ? (
            <div className={disabled ? classes.manuallyDisabled : ''}>
              {customStartButton as unknown as React.ReactNode}
            </div>
          ) : (
            startButtonText && (
              <Button
                type="primary"
                disabled={disabled}
                onClick={
                  disabled
                    ? () => null
                    : () => {
                        enableQuiz ? setOpenQuiz(true) : handleStart();
                      }
                }
              >
                {enableQuiz ? 'Go To Concept Review' : startButtonText}
              </Button>
            )
          )}
        </div>
      </Tooltip>
    </div>
  );
};

const useStyles = makeStyles(theme => ({
  container: {
    width: '100%',
    padding: 20,
    background: 'white',
    position: 'fixed',
    bottom: 0,
    right: 0,
    borderTop: `1px solid ${theme.colors.gray20}`,
    display: 'flex',
  },

  startButton: {
    backgroundColor: Colors.ScaleBlue,
    color: 'white',
    borderRadius: '0.5rem',
    marginLeft: 'auto',
    display: 'inline-block',
  },

  // For custom buttons - gray out content and disable pointer events
  manuallyDisabled: {
    filter: 'grayscale(1)',
    pointerEvents: 'none',
  },
}));

export default StickyFooter;
